import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyContent from "./sections/PrivacyPolicyContent";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicyContent />
      <Footer />
    </div>;
}